<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="content-heading">
	<h3>{{locoLabel?.locoTripPlan|uppercase}}</h3>
</div>
<div class="loco-trip-plan-scroll">
	<lms-loco-trip-plan *ngFor='let trip of listOfTripPlan' [tripPlan]='trip' [locoLabel]='locoLabel'></lms-loco-trip-plan>
</div>